<template>
  <el-dialog :title="title" :visible.sync="visible" :close-on-click-modal="false" append-to-body @opened="openFun">
    <el-form :model="entity" :rules="rules" ref="flowRef" label-width="120px">
      <el-form-item label="订单号" prop="orderNo">
        <el-input v-model="entity.orderNo" disabled></el-input>
      </el-form-item>
      <el-form-item label="结清类型" prop="SettleType">
        <el-select v-model="entity.SettleType" clearable placeholder="结清类型">
          <el-option v-for="item in $dict.map['order_after_status']" :key="item.value" :label="item.name"
                     :value="item.value"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="resetForm('flowRef')">重置</el-button>
      <el-button type="primary" :loading="isLoading" @click="submitForm('flowRef')">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {successMsg} from "@/utils/message";
import {orderClear} from "@/api/order/order";

export default {
  name: "orderClearDialog",
  components: {},
  props: {
    dialogVisible: {
      type: Boolean,
      require: true,
      default: false
    },
    orderNo: {
      type: String,
      require: true,
      default: ''
    }
  },
  computed: {
    visible: {
      get: function () {
        return this.dialogVisible
      },
      set: function (val) {
        this.$emit('update:dialogVisible', val)
      }
    }
  },
  data() {
    return {
      title: '打款',
      isLoading: false,
      uploading: false,
      fileList: [],
      entity: {
        orderNo: '',
        SettleType: ''
      },
      rules: {
        orderNo: [{required: true, message: '订单号不能为空', trigger: 'blur'}],
        SettleType: [{required: true, message: '请选择结清类型', trigger: 'change'}],
      },
      options: []
    }
  },
  methods: {
    resetForm(formName) {
      this.entity = {
        orderNo: this.orderNo,
        SettleType: ''
      }
      //清除验证
      this.$refs[formName].clearValidate()
    },
    openFun() {
      this.resetForm('flowRef')
    },
    //  提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isLoading = true
          orderClear(this.entity).then(() => {
            successMsg('操作成功')
            this.visible = false
            this.$emit('operate:success')
            this.isLoading = false
          }).catch(() => {
            this.isLoading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>
::v-deep .vue-treeselect__control {
  height: 28px;
}

::v-deep .el-form-item__content {
  line-height: 28px;
  font-size: 12px;
}
</style>
